import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.header');
import { OnInit, DoCheck } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Router } from '@angular/router';

@Component({
    selector: 'wiz-component-header',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.header/view.scss */
/* src/app/component.header/view.scss: no such file or directory */`],
})
export class ComponentHeaderComponent implements OnInit, DoCheck {

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public languageOpen = false;
    public currentUrl: any;
    public first = "";
    public second = "";
    public third = "";
    public forth = "";
    public menu: any;
    public currentMenu: any;

    public userMenu = [
        { label: "대시보드", path: "dashboard", isLink: true },
        { label: "공지사항", path: "notice", isLink: true },
        { label: "기술지원", path: "support", isLink: true },
        { label: "연구성과", path: "research", isLink: true },
        { label: "게시판", path: "board", isLink: true },
        { label: "스토리지", path: "storage", isLink: true },
        { label: "연구그룹", path: "group", isLink: true },
        { label: "마이페이지", path: "mypage", isLink: true }
    ];
    public groupMenu = [
        { label: "정보", path: "info", isLink: true },
        { label: "연구그룹 연구자", path: "user", isLink: true }
    ];
    public communityMenu = [
        { label: "정보", path: "info", isLink: true },
        { label: "연구 그룹", path: "group", isLink: true },
        { label: "연구커뮤니티 연구자", path: "user", isLink: true }
    ];
    public adminMenu = [
        { label: "그룹 메일", path: "group-mail", isLink: true },
        { label: "운영 로그", path: "logs", isLink: true },
        { label: "전체 사용자", path: "users", isLink: true },
        { label: "승인 요청 관리", path: "request", isLink: true },
        { label: "커뮤니티 관리", path: "community", isLink: true },
        { label: "티켓팅 관리", path: "ticketing", isLink: true },
        { label: "FAQ 관리", path: "faq", isLink: true },
        { label: "매뉴얼 관리", path: "manual", isLink: true },
        { label: "성과 관리", path: "research", isLink: true },
        { label: "공지사항 관리", path: "notice", isLink: true },
        { label: "게시판 관리", path: "board", isLink: true },
        { label: "스토리지 관리", path: "storage", isLink: true },
        { label: "매뉴얼 이미지 관리", path: "image", isLink: true },
        { label: "비밀번호 변경", path: "password", isLink: true }
    ];

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public restoringAdmin = false;
    public async restoreAdmin() {
        if (this.restoringAdmin) return;
        this.restoringAdmin = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('restore_admin');
            if (code !== 200) throw new Error(typeof data === 'string' ? data : '관리자 복귀에 실패했습니다.');
            window.location.assign(data.redirect);
        } catch (error) {
            await this.service.alert.error(error.message || '관리자 복귀에 실패했습니다.');
            this.restoringAdmin = false;
            await this.service.render();
        }
    }

    public async toggleTheme() {
        this.service.theme.toggle();
        await this.service.render();
    }

    public async toggleLanguageMenu() {
        this.languageOpen = !this.languageOpen;
        await this.service.render();
        if (this.languageOpen) this.focusLanguage();
    }

    private focusLanguage(index?: number) {
        const options = Array.from(document.querySelectorAll<HTMLButtonElement>('#portal-header-language-menu button'));
        const selected = options.findIndex(option => option.getAttribute('aria-checked') === 'true');
        options[index ?? Math.max(0, selected)]?.focus();
    }

    public async selectLanguage(language: 'ko' | 'en') {
        this.service.i18n.set(language);
        this.languageOpen = false;
        await this.service.render();
        document.getElementById('portal-header-language-trigger')?.focus();
    }

    public async dismissLanguage(event: Event) {
        if (!this.languageOpen) return;
        const control = document.querySelector('.gsdc-page-header__language-control');
        if (control?.contains(event.target as Node)) return;
        this.languageOpen = false;
        await this.service.render();
    }

    public async languageKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape' && this.languageOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.languageOpen = false;
            await this.service.render();
            document.getElementById('portal-header-language-trigger')?.focus();
        } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            if (!this.languageOpen) { await this.toggleLanguageMenu(); return; }
            const options = Array.from(document.querySelectorAll('#portal-header-language-menu button'));
            const current = options.indexOf(document.activeElement);
            const next = event.key === 'Home' ? 0 : event.key === 'End' ? options.length - 1
                : (current + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length;
            this.focusLanguage(next);
        }
    }

    public get breadcrumbs(): string[] {
        return [this.first, this.second, this.third, this.forth].filter(Boolean);
    }

    public async ngDoCheck() {
        const url = this.router.url.split(/[?#]/)[0];
        if (this.currentUrl !== url) {
            this.languageOpen = false;
            this.currentUrl = url;
            this.first = this.second = this.third = this.forth = '';
            let segment = url.split('/').filter(Boolean);

            if (segment[0] === 'admin') {
                this.menu = this.adminMenu;
                segment = segment.slice(1);
            } else {
                this.menu = this.userMenu;
            }
            this.first = this.menu.find(item => segment[0] === item.path)?.label || 'GSDC';


            if (segment.length > 1) {
                this.second = '';
                this.third = '';

                const has = (...keys: string[]) => keys.some(k => segment.includes(k));
                const isCreate = () => has('create', 'new', 'write');
                const isDetail = () => has('detail', 'view', 'id', 'show');

                if (this.first === '기술지원') {
                    if (has('manual')) {
                        this.second = '매뉴얼';
                    } else if (has('ticketing')) {
                        this.second = '문의하기';

                        const idx = segment.indexOf('ticketing');
                        const tail = segment[idx + 1]; // ticketing 뒤에 오는 값(없으면 목록)

                        if (!tail) {
                            this.third = '';
                        } else if (['new', 'create', 'write'].includes(tail)) {
                            this.third = '작성';
                        } else {
                            this.third = '상세보기';
                        }

                    } else if (has('faq')) {
                        this.second = 'FAQ';

                        const idx = segment.indexOf('faq');
                        const tail = segment[idx + 1]; // faq 뒤(없으면 목록)

                        if (!tail) {
                            this.third = '';
                        } else if (['new', 'create', 'write'].includes(tail)) {
                            this.third = '작성';
                        } else {
                            this.third = '상세보기';
                        }
                    }
                } else if (this.first === '연구성과') {
                    if (isCreate()) this.second = '작성';
                    else this.second = '상세보기';
                } else if (this.first === '연구그룹') {
                    if (has('list')) this.second = '그룹 목록';
                    else if (has('request', 'requests')) this.second = '신청·승인 내역';
                } else if (this.first === '공지사항') {
                    this.second = '상세보기';
                } else if (this.first === '게시판') {
                    if (isCreate()) this.second = '작성';
                    else this.second = '상세보기';
                }

                else if (this.first === '커뮤니티 관리') {
                    this.second = '';
                    this.third = '';
                    this.forth = '';

                    const segments = this.currentUrl.split('/').filter(Boolean);
                    const idx = segments.indexOf('community');
                    const after = segments.slice(idx + 1);

                    const cid = after[0];          // communityID
                    const maybeGroupId = after[1]; // 숫자면 groupID
                    const isGroupContext = after.length >= 3 && ['info', 'user'].includes(after[2]);

                    this.second = '커뮤니티';

                    if (!cid || cid === 'all') {
                        this.second = this.service.auth.session?.role === 'admin' ? '커뮤니티 관리' : '가입 절차';
                    } else if (isGroupContext) {
                        this.third = '연구그룹';

                        const mode = after[2] || 'info';

                        if (mode === 'info') {
                            this.forth = '그룹 정보';
                        } else if (mode === 'user') {
                            this.forth = '그룹 구성원';
                        } else if (mode === 'group') {
                            this.forth = '연구그룹';
                        } else {
                            this.forth = ''; // 기타
                        }
                    } else {
                        const mode = after[1] || 'info';

                        if (mode === 'info') {
                            this.third = '정보';
                            this.forth = '';
                        } else if (mode === 'group') {
                            this.third = '연구그룹';
                            this.forth = '';
                        } else if (mode === 'user') {
                            this.third = '연구자';
                            this.forth = '';
                        }
                    }
                } else if (this.first === '티켓팅 관리') {
                    this.second = '상세보기';
                } else if (this.first === 'FAQ 관리') {
                    if (isCreate()) this.second = '작성';
                    else this.second = '상세보기';
                } else if (this.first === '공지사항 관리') {
                    if (isCreate()) this.second = '작성';
                    else this.second = '상세보기';
                } else if (this.first === '성과 관리') {
                    this.second = '상세보기';
                } else if (this.first === '전체 사용자') {
                    if (isCreate()) this.second = '신규 생성';
                } else if (this.first === '게시판 관리') {
                    this.second = '상세보기';
                }
            }
            await this.service.render();
        }
    }
}

export default ComponentHeaderComponent;